export const valoresExibidosOffCanvasTickets: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorTags: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface SisAF',
  versaoSisaf: 'Versão SisAF',
  moduloSisAf: 'Módulo SisAF',
  tipoTicket: 'Tipo de Ticket',
  statusTicket: 'Status',
  mensagemUsuario: 'Mensagem',
  dataInicio: 'Data de Início da Análise',
  dataRetorno: 'Data de Retorno',
  retornoDevs: 'Retorno Devs',
  responsavelDev: 'Responsável pelo Retorno',
  responsavel: 'Usuário',
  dataEnvio: 'Data do Ticket',
};

export const headersTickets = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: '' },
  { text: 'Status', width: 12, key: '' },
  { text: 'Módulo', width: 10, key: '' },
  { text: 'Tipo', width: 10, key: '' },
  { text: 'Data Ticket', width: 10, key: '' },
  { text: 'Usuário', width: 10, key: '' },
  { text: 'Resp. Dev', width: 10, key: '' },
  { text: 'Mensagem', width: 65, key: '' },
];

export const fieldObjectTickets = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
